import { render, staticRenderFns } from "./DoordashKeys.vue?vue&type=template&id=f112d54c&"
import script from "./DoordashKeys.vue?vue&type=script&lang=js&"
export * from "./DoordashKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f112d54c')) {
      api.createRecord('f112d54c', component.options)
    } else {
      api.reload('f112d54c', component.options)
    }
    module.hot.accept("./DoordashKeys.vue?vue&type=template&id=f112d54c&", function () {
      api.rerender('f112d54c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamCarriers/components/DoordashKeys.vue"
export default component.exports